<template>
  <div class="mc-modal" id="measurementsTable" :class="{isOpen: isOpen && hasTable}">
    <div class="mc-modal__outer">
      <div class="mc-modal__inner">
        <div class="mc-modal__heading">
          <span class="mc-modal__line"></span>
          <button @click="$emit('close')" class="mc-modal__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
            <svg class="mc-modal__close-icon" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
            </svg>
          </button>
          <div class="mc-modal__title" v-html="measurements.title_html"></div>
        </div>
        <div class="mc-modal__body">
          <div class="mc-modal__content">
            <div v-if="measurements.text_html" class="mc-modal__text" v-html="measurements.text_html"></div>
            <div class="mc-measurements">
              <div v-if="measurements.image" class="mc-measurements__image">
                <img :src="measurements.image" alt="Обмеры изделия">
              </div>
              <div class="mc-measurements__table-wrapper">
                <table>
                  <thead>
                  <tr>
                    <th v-for="column in columns" :key="columnCode(column)">
                      {{ columnName(column) }}
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
                    <td v-for="column in columns" :key="columnCode(column)">
                      {{ rowValue(row, column) }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="measurements.footer_html || links.length" class="mc-measurements__footer">
              <div v-if="measurements.footer_html" class="mc-modal__text" v-html="measurements.footer_html"></div>
              <ul v-if="links.length" class="mc-measurements__social">
                <li v-for="link in links" :key="link.link" class="mc-measurements__social-item">
                  <a :href="link.link" class="mc-measurements__social-link" target="_blank">
                    <img v-if="link.icon" :src="link.icon" :alt="link.text">
                    <span>{{ link.text }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="mc-modal__bottom">
          <button @click="$emit('close')" class="mc-button mc-button--color js-button-close simulated-hover" type="button">
            <span class="mc-button__text">
              Закрыть
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: false,
    measurements: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['close'],
  computed: {
    columns() {
      return Array.isArray(this.measurements.columns) ? this.measurements.columns : [];
    },
    rows() {
      return Array.isArray(this.measurements.rows) ? this.measurements.rows : [];
    },
    hasTable() {
      return this.columns.length > 0 && this.rows.length > 0;
    },
    links() {
      return Array.isArray(this.measurements.links) ? this.measurements.links : [];
    }
  },
  methods: {
    columnCode(column) {
      return column.CODE || column.code || '';
    },
    columnName(column) {
      return column.NAME || column.name || '';
    },
    rowValue(row, column) {
      const code = this.columnCode(column);
      return code && row[code] ? row[code] : '';
    }
  }
}
</script>

<style scoped>
.mc-measurements {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mc-measurements__image img {
  display: block;
  width: 100%;
  height: auto;
}

.mc-measurements__table-wrapper {
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.mc-measurements__table-wrapper table {
  min-width: 100%;
  width: max-content;
}

.mc-measurements__table-wrapper th,
.mc-measurements__table-wrapper td {
  min-width: 90px;
  white-space: nowrap;
}

.mc-measurements__footer {
  margin-top: 16px;
}

.mc-measurements__social {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 14px;
  padding: 0;
  margin: 12px 0 0;
  list-style: none;
}

.mc-measurements__social-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: inherit;
  text-decoration: none;
}

.mc-measurements__social-link img {
  width: 18px;
  height: 18px;
  object-fit: contain;
}
</style>
